import React, { useState } from "react";
//import PlanOverride from "../../../pages/LookUps/PlanOverride/PlanOverride";
//import BenefitMaxSchedule from "../../../pages/BenefitMaxSchedule/BenefitMaxSchedule";
import CopaySchedule from "../../../pages/CopaySchedule/CopaySchedule";
import FormularyStatus from "../../../pages/Lookups/FormularyStatusList/FormularyStatusList";
import SuperNetwork from "../../../pages/Lookups/SuperNetwork/SuperNetwork";
import MaxCopaySchedule from "../../../pages/MaxCopaySchedule/MaxCopaySchedule";
import PatientPaySchedule from "../../../pages/PatientPaySchedule/PatientPaySchedule";
import PatientPayTable from "../../../pages/PatientPayTable/PatientPayTable";
import PharmacyList from "../../../pages/Lookups/PharmacyList/PharmacyList";
import AdditonalPatientPayLookUp from "../MiscComponents/AdditonalPatientPayLookUp";
import PatientPayScheduleForm from "../../../pages/PatientPaySchedule/PatientPayScheduleForm";
import { PRICE_SCHEDULE_MODES } from "../../utils/Constants";
import PatientPayTableDetailForm from "../../../pages/PatientPayTable/PatientPayTableDetailForm";
import GPILookup from "../../../pages/Lookups/GpiScreen/GpiLookup";
import CopayScheduleStepForm from "../../../pages/CopaySchedule/CopayScheduleStepForm";
import NonStateCostSourceAndType from "../../../pages/Lookups/NonStateCostSourceAndType/NonStateCostSourceAndType";
import CopayScheduleStepLookUp from "../MiscComponents/CopayScheduleStepLookUp";

const LocalLookup = ({
  sourceData,
  screenNumber,
  params,
  receiveData,
  hideModal,
  readOnly,
  onNavigate,
}) => {
  const { default: lookupScreen } = screenNumber;

  const { lookupType, fieldMapping, disabledDropdown = false } = params;
  console.log("source", sourceData);
  const selectParams = fieldMapping["default"];
  const paramsData = selectParams.reduce((acc, item) => {
    if (item["paramDataKey"] && !readOnly) {
      acc[item["paramDataKey"]] = sourceData[item["source"]];
    } else {
      acc[item["target"]] = sourceData[item["source"]];
    }

    return acc;
  }, {});
  switch (lookupScreen) {
    case "RCPLN018":
      return {
        /*<PlanOverride
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
        /> */
      };
    case "RCBSC005":
      return {
        /* <BenefitMaxSchedule
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
        />*/
      };
    case "RCAPS004":
      return (
        <AdditonalPatientPayLookUp
          intialSchedule={sourceData}
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          scheduleFlag={false}
          selectParamsData={paramsData}
          readOnly={readOnly}
          initialSelectedPatient={[paramsData]}
          mode={readOnly ? PRICE_SCHEDULE_MODES.READ_ONLY : ""}
          disabledDropdown={disabledDropdown}
          onNavigate={onNavigate}
        />
      );
    case "RCAPT004":
      return (
        <AdditonalPatientPayLookUp
          intialSchedule={sourceData}
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          scheduleFlag={true}
          onNavigate={onNavigate}
        />
      );
    case "RCPS3001":
      if (readOnly) {
        return (
          <PatientPayScheduleForm
            selectMode={true}
            hideModal={hideModal}
            lookupType={lookupType}
            initialSelectedPatient={[paramsData]}
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
          />
        );
      }
      return (
        <PatientPaySchedule
          intialSchedule={sourceData}
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          scheduleFlag={true}
          selectParamsData={paramsData}
          disabledDropdown={disabledDropdown}
          onNavigate={onNavigate}
        />
      );
    case "RCGPI031":
      return (
        <GPILookup
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          onSelect={receiveData}
          fieldMapping={fieldMapping}
          paramsData={paramsData}
          onNavigate={onNavigate}
        />
      );
    case "RCPS4035":
      if (readOnly) {
        return (
          <PatientPayTableDetailForm
            params={fieldMapping.default}
            onSelect={receiveData}
            hideModal={hideModal}
            selectMode={true}
            // lookupType={lookupType}
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
            intialSchedule={sourceData}
          />
        );
      }
      return (
        <PatientPayTable
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          selectParamsData={paramsData}
          onNavigate={onNavigate}
        />
      );
    case "RCCSH004":
      if (readOnly) {
        return (
          <CopayScheduleStepForm
            paramsDesc={fieldMapping.default}
            onSelect={receiveData}
            hideModal={hideModal}
            selectMode={true}
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
            intialSchedule={paramsData}
            sourceData={sourceData}
          />
        );
      }
      return (
        <CopayScheduleStepLookUp
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          selectParamsData={paramsData}
          sourceData={sourceData}
          onNavigate={onNavigate}
        />
      );
    case "RCFS1005":
      return (
        <FormularyStatus
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          selectParamsData={paramsData}
        />
      );

    case "RCMCY001":
      return (
        <MaxCopaySchedule
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          onNavigate={onNavigate}
        />
      );
    case "RCPAL004":
      return (
        <PharmacyList
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          selectParamsData={paramsData}
        />
      );
    case "RCPS4005":
      return (
        <PatientPayTableDetailForm
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          mode={PRICE_SCHEDULE_MODES.READ_ONLY}
          intialSchedule={sourceData}
          onNavigate={onNavigate}
        />
      );

    case "RCCSS001":
      return (
        <NonStateCostSourceAndType
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          mode={PRICE_SCHEDULE_MODES.READ_ONLY}
          selectParamsData={paramsData}
          onNavigate={onNavigate}
        />
      );

    case "RCSNH990":
      return (
        <SuperNetwork
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          selectParamsData={paramsData}
        />
      );
    default:
      return null;
  }
};
export default LocalLookup;
